const lang={
    en:{
        search:"Search",
        gptSearchPlaceholder:"What do you want to watch today?"
    },
    hindi:{
        search:"खोज",
        gptSearchPlaceholder:"आज आप क्या देखना चाहते हैं?"
    },
    spanish:{
        search:"Buscar",
        gptSearchPlaceholder:"¿Qué quieres ver hoy?"
    }
}
export default lang;